import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { IconButton, Tooltip, TooltipProps } from "@mui/material";
import React, { ReactNode, forwardRef } from "react";
import { useAppSelector } from "src/redux/hooks";

interface InfoTooltipProps {
  title: ReactNode;
  icon?: ReactNode;
  size?: "small" | "medium" | "large";
  placement?: TooltipProps["placement"];
  arrow?: boolean;
  sx?: any;
  TooltipProps?: Partial<TooltipProps>;
}

const InfoTooltip = forwardRef<HTMLButtonElement, InfoTooltipProps>(
  ({ title, icon, size = "small", placement = "top", arrow = true, sx, TooltipProps, ...other }, ref) => {
    const showInfoTooltips = useAppSelector((state) => state.system.showInfoTooltips);

    if (!showInfoTooltips) {
      return null;
    }

    const IconComponent = icon || <HelpOutlineIcon fontSize={size === "large" ? "medium" : "small"} />;

    return (
      <Tooltip
        title={title}
        placement={placement}
        arrow={arrow}
        enterDelay={100}
        leaveDelay={200}
        {...TooltipProps}
      >
        <IconButton
          ref={ref}
          size={size}
          sx={{
            color: "text.secondary",
            padding: 0.5,
            "&:hover": {
              color: "primary.main",
              backgroundColor: "action.hover",
            },
            ...sx,
          }}
          {...other}
        >
          {IconComponent}
        </IconButton>
      </Tooltip>
    );
  }
);

InfoTooltip.displayName = "InfoTooltip";

export default InfoTooltip;
